/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Under_Age_TitleInputs */

const en_us2_body_assessment_under_age_title = /** @type {(inputs: Body_Assessment_Under_Age_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available from age 15`)
};

const pt_br2_body_assessment_under_age_title = /** @type {(inputs: Body_Assessment_Under_Age_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponível a partir dos 15 anos`)
};

const es_419_body_assessment_under_age_title = /** @type {(inputs: Body_Assessment_Under_Age_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible a partir de los 15 años`)
};

const pt_pt2_body_assessment_under_age_title = /** @type {(inputs: Body_Assessment_Under_Age_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponível a partir dos 15 anos`)
};

const fr_fr2_body_assessment_under_age_title = /** @type {(inputs: Body_Assessment_Under_Age_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponible dès 15 ans`)
};

const de_de2_body_assessment_under_age_title = /** @type {(inputs: Body_Assessment_Under_Age_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbar ab 15 Jahren`)
};

const it_it2_body_assessment_under_age_title = /** @type {(inputs: Body_Assessment_Under_Age_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibile dai 15 anni`)
};

/**
* | output |
* | --- |
* | "Available from age 15" |
*
* @param {Body_Assessment_Under_Age_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_under_age_title = /** @type {((inputs?: Body_Assessment_Under_Age_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Under_Age_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_under_age_title(inputs)
	if (locale === "es-419") return es_419_body_assessment_under_age_title(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_under_age_title(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_under_age_title(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_under_age_title(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_under_age_title(inputs)
	return en_us2_body_assessment_under_age_title(inputs)
});
export { body_assessment_under_age_title as "body-assessment.under_age_title" }